import {ChronologicalCommentsSort} from '@github-ui/commenting/useCommentsSortPreference'
import {SortAscIcon, SortDescIcon} from '@primer/octicons-react'
import {ActionList, ActionMenu} from '@primer/react'

import {TEST_IDS} from '../../constants/test-ids'

const sortConfigs = {
  [ChronologicalCommentsSort.OldestFirst]: {shortLabel: 'Oldest', label: 'Oldest first', Icon: SortAscIcon},
  [ChronologicalCommentsSort.NewestFirst]: {shortLabel: 'Newest', label: 'Newest first', Icon: SortDescIcon},
} as const

const availableSorts = [ChronologicalCommentsSort.NewestFirst, ChronologicalCommentsSort.OldestFirst] as const

type CommentsSortMenuProps = {
  sort: ChronologicalCommentsSort
  onSortChange: (sort: ChronologicalCommentsSort) => void
}

export function CommentsSortMenu({sort: currentSort, onSortChange}: CommentsSortMenuProps) {
  const {Icon: CurrentSortIcon, shortLabel: currentSortLabel} = sortConfigs[currentSort]

  return (
    <ActionMenu>
      <ActionMenu.Button
        leadingVisual={CurrentSortIcon}
        aria-label={`Sort comments: ${currentSortLabel}`}
        data-testid={TEST_IDS.commentsSortMenuButton}
      >
        {currentSortLabel}
      </ActionMenu.Button>
      <ActionMenu.Overlay>
        <ActionList selectionVariant="single">
          {availableSorts.map(sort => {
            const {label, Icon} = sortConfigs[sort]
            return (
              <ActionList.Item key={sort} selected={sort === currentSort} onSelect={() => onSortChange(sort)}>
                <ActionList.LeadingVisual>
                  <Icon />
                </ActionList.LeadingVisual>
                {label}
              </ActionList.Item>
            )
          })}
        </ActionList>
      </ActionMenu.Overlay>
    </ActionMenu>
  )
}
